import React from 'react';
import { Box, Divider, FormControlLabel, Switch } from '@mui/material';
import { GlobalSettingsNumberGrid } from '../../../pages/admin/GlobalSettingsNumberGrid';
import {
  adminAgentApprovalNumberFields,
  adminAgentConnectionNumberFields,
  adminAgentLimitNumberFields,
  adminAgentOutputNumberFields,
} from '../../../pages/admin/global-settings.config';
import { SettingsSectionHeader } from './SettingsSectionHeader';
import { DenyPatternsField } from './DenyPatternsField';
import type { AdminAgentSectionProps } from './settingsSectionTypes';

export const AdminAgentSection: React.FC<AdminAgentSectionProps> = ({
  config,
  onNumberChange,
  onBooleanChange,
  onDenyPatternsChange,
}) => (
  <>
    <SettingsSectionHeader
      title="Admin assistant"
      description="The bubble chat in this admin site. It reads data on its own and can only change or delete after the admin approves. Its LLM usage is paid by the platform, not charged to any package."
    />
    <Box className="mb-5">
      <FormControlLabel
        control={
          <Switch
            checked={config.adminAgentEnabled}
            onChange={(event) => onBooleanChange('adminAgentEnabled', event.target.checked)}
          />
        }
        label="Enable the admin assistant"
      />
    </Box>

    <Divider className="my-6" />

    <SettingsSectionHeader
      title="Usage limits"
      description="Per admin. The assistant refuses new messages once a limit is hit."
    />
    <GlobalSettingsNumberGrid
      config={config}
      fields={adminAgentLimitNumberFields}
      onNumberChange={onNumberChange}
    />

    <Divider className="my-6" />

    <SettingsSectionHeader
      title="Change approval"
      description="Limits on change/delete requests the assistant proposes. Nothing runs until the admin approves."
    />
    <GlobalSettingsNumberGrid
      config={config}
      fields={adminAgentApprovalNumberFields}
      columns={3}
      onNumberChange={onNumberChange}
    />

    <Divider className="my-6" />

    <SettingsSectionHeader
      title="Data access"
      description="How much the assistant can read and how large the results it sees may be."
    />
    <GlobalSettingsNumberGrid
      config={config}
      fields={adminAgentOutputNumberFields}
      columns={3}
      onNumberChange={onNumberChange}
    />

    <Divider className="my-6" />

    <SettingsSectionHeader
      title="Blocked APIs"
      description="API paths the assistant must never call, on top of the built-in blocks (its own approval endpoints, credentials, payments, prompts)."
    />
    <DenyPatternsField
      patterns={config.adminAgentExtraDenyPatterns}
      onChange={onDenyPatternsChange}
    />

    <Divider className="my-6" />

    <SettingsSectionHeader
      title="Chat connection"
      description="How the chat socket authenticates."
    />
    <GlobalSettingsNumberGrid
      config={config}
      fields={adminAgentConnectionNumberFields}
      columns={3}
      onNumberChange={onNumberChange}
    />
  </>
);
